import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["videoInput", "videoPreview"]

  connect() {
    this.initializeVideoPreview()
  }

  initializeVideoPreview() {
    if (this.hasVideoInputTarget && this.hasVideoPreviewTarget) {
      // Actualizar preview inicial
      this.updateVideoPreview(this.videoInputTarget.value, this.videoPreviewTarget)
    }
  }

  // Action que se ejecuta cuando cambia el input de video
  updatePreview(event) {
    this.updateVideoPreview(event.target.value, this.videoPreviewTarget)
  }

  updateVideoPreview(url, previewElement) {
    if (!url || url.trim() === '') {
      previewElement.innerHTML = ''
      return
    }

    let videoId
    let embedUrl

    if (url.includes('youtube.com') || url.includes('youtu.be')) {
      videoId = this.extractYoutubeId(url)
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}`
      }
    } else if (url.includes('vimeo.com')) {
      videoId = this.extractVimeoId(url)
      if (videoId) {
        embedUrl = `https://player.vimeo.com/video/${videoId}`
      }
    }

    if (embedUrl) {
      previewElement.innerHTML = `
        <iframe class="d-block w-100" 
                src="${embedUrl}" 
                title="Video player" 
                frameborder="0" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
        </iframe>`
    } else {
      previewElement.innerHTML = '<div class="alert alert-warning">URL de video no válida. Soportamos YouTube y Vimeo.</div>'
    }
  }

  extractYoutubeId(url) {
    const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/
    const match = url.match(regExp)
    return (match && match[2].length === 11) ? match[2] : null
  }

  extractVimeoId(url) {
    const match = url.match(/vimeo\.com\/(\d+)/)
    return match ? match[1] : null
  }
}